import { render, staticRenderFns } from "./servizio.vue?vue&type=template&id=2f247ff8"
import script from "./servizio.vue?vue&type=script&lang=js"
export * from "./servizio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports